import React from "react";
import "../styles/AdminDateSliderBar.css";
import { useTranslation } from "react-i18next";

const DAYS_PER_PAGE = 14;
const MAX_WEEKS = 7;

const getNextNDays = (startOffset, count) => {
  const days = [];
  const today = new Date();

  for (let i = 0; i < count; i++) {
    const future = new Date(today);
    future.setDate(today.getDate() + startOffset + i);

    const dateStr = future.toLocaleDateString("en-CA");
    const label = future.toLocaleDateString("en-US", {
      weekday: "short",
      day: "numeric",
      month: "short",
    });

    days.push({ dateStr, label });
  }

  return days;
};

const AdminDateSliderBar = ({
  selectedDate,
  onSelectDate,
  isLoading,
  weekOffset,
  setWeekOffset,
}) => {
  const { t } = useTranslation();

  const startDayOffset = weekOffset * DAYS_PER_PAGE;
  const dates = getNextNDays(startDayOffset, DAYS_PER_PAGE);

  const handleNext = () => {
    if (weekOffset < MAX_WEEKS - 1) {
      setWeekOffset((prev) => prev + 1);
      onSelectDate(null); 
    }
  };
  

  const handlePrev = () => {
    if (weekOffset > 0) {
      setWeekOffset((prev) => prev - 1);
      onSelectDate(null); 
    }
  };
  

  return (
    <div className="date-slider-row-wrapper">
      <button
        className="slider-arrow-btn left"
        onClick={handlePrev}
        disabled={weekOffset === 0}
        aria-label={t("admin_sched.prev_week")}
      >
      </button>
  
      <div className="date-grid-new">
        {isLoading ? (
          <div className="loading-spinner_v3">
            {t("admin_sched.loading_dates")}
          </div>
        ) : (
          dates.map((d) => (
            <button
              key={d.dateStr}
              className={`date-grid-btn ${selectedDate === d.dateStr ? "selected" : ""}`}
              onClick={() => onSelectDate(d.dateStr)}
            >
              {d.label}
            </button>
          ))
        )}
      </div>
  
      <button
        className="slider-arrow-btn right"
        onClick={handleNext}
        disabled={weekOffset === MAX_WEEKS - 1}
        aria-label={t("admin_sched.next_week")}
      >
      </button>
    </div>
  );
  
};

export default AdminDateSliderBar;
